var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiutrnactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.70462 21 0 16.2823 0 10.5001C0 4.71789 4.71776 0 10.5 0C16.2822 0 21 4.71789 21 10.5001C21 16.2823 16.2822 21 10.5 21ZM10.5 0.814757C5.16457 0.814757 0.814763 5.1647 0.814763 10.5001C0.814763 15.8355 5.16457 20.1852 10.5 20.1852C15.8354 20.1852 20.1852 15.8355 20.1852 10.5001C20.1852 5.1647 15.8354 0.814757 10.5 0.814757Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5754 11L10.0137 10.7805L10 10.4651V0H10.8493V9.47758L17.3835 2.63347L18 3.22315L10.5754 11Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7096 10.1927L10.1016 10.7461L16.7512 18.5113L17.3592 17.9578L10.7096 10.1927Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 7H13V8H20V7Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10H11V11H21V10Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14H14V15H20V14Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiutrnactive);
export default __webpack_public_path__ + "static/media/biểu đồ tròn active.cc93277ddf778e07b0d98ace70564677.svg";
export { ForwardRef as ReactComponent };